import { render, staticRenderFns } from "./balance-menu.vue?vue&type=template&id=088ee14b&"
import script from "./balance-menu.vue?vue&type=script&lang=js&"
export * from "./balance-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports